import React, { useState } from "react";
import "./Navbar.css";
import logo from "../../assets/logos/verze1.webp";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({
    about: false,
    services: false,
  });

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const toggleDropdown = (name) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  return (
    <nav className='navbar'>
      <div className='logo'>
        <Link to={"/"}>
          <img src={logo} alt='Logo' className='navbar-logo' />
        </Link>
      </div>
      <div className='navbar-links'>
        <Link to={"/"} className='navbar-link'>
          Úvod
        </Link>
        <div
          className='navbar-dropdown'
          onMouseEnter={() => toggleDropdown("about")}
          onMouseLeave={() => toggleDropdown("about")}
        >
          <Link
            to={"/divadloDI"}
            className='navbar-link'
            onClick={() => toggleDropdown("about")}
          >
            Divadlo DI ▼
          </Link>
          <div className={`dropdown-menu ${dropdownOpen.about ? "show" : ""}`}>
            <Link to={"/divadloDI"} className='dropdown-item'>
              DI
            </Link>
            <Link to={"/divadloDI#team"} className='dropdown-item'>
              Herci
            </Link>
            <Link to={"/divadloDI#co-creators"} className='dropdown-item'>
              Spolutvůrci
            </Link>
          </div>
        </div>
        <div
          className='navbar-dropdown'
          onMouseEnter={() => toggleDropdown("services")}
          onMouseLeave={() => toggleDropdown("services")}
        >
          <Link
            to={"/repertoar"}
            className='navbar-link'
            onClick={() => toggleDropdown("services")}
          >
            Repertoár ▼
          </Link>
          <div
            className={`dropdown-menu ${dropdownOpen.services ? "show" : ""}`}
          >
            <Link to={"/repertoar#forKids"} className='dropdown-item'>
              Pro děti
            </Link>
            <Link to={"/repertoar#forAdult"} className='dropdown-item'>
              Pro dospělé
            </Link>
            <Link to={"/repertoar#archive"} className='dropdown-item'>
              Archiv
            </Link>
          </div>
        </div>
        <Link to={"/program"} className='navbar-link'>
          Program
        </Link>
        <Link to={"/kontakty"} className='navbar-link'>
          Kontakt
        </Link>
        <a
          href='https://www.instagram.com/divadlo_di/'
          className='navbar-icon ig'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='fab fa-instagram'></i>
        </a>
        <a
          href='https://www.facebook.com/people/Divadeli%C3%A9r-Vysok%C3%A9-M%C3%BDto/61580111814101/'
          className='navbar-icon fb'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='fab fa-facebook'></i>
        </a>
        <Link to={"/adminlogin"}>
          <i className='fa-solid fa-pen-to-square navbar-icon'></i>
        </Link>
      </div>
      <div
        className={`hamburger ${isOpen ? "open" : ""}`}
        onClick={toggleNavbar}
      >
        <span className='bar'></span>
        <span className='bar'></span>
        <span className='bar'></span>
      </div>
      <div className={`navbar-mobile-links ${isOpen ? "open" : ""}`}>
        <Link to={"/"} className='navbar-link'>
          Úvod
        </Link>
        <div className='navbar-dropdown-mobile'>
          <Link
            to={"/divadloDI"}
            className='navbar-link'
            onClick={() => toggleDropdown("about")}
          >
            Divadlo DI ▼
          </Link>
          <div
            className={`dropdown-menu-mobile ${
              dropdownOpen.about ? "show" : ""
            }`}
          >
            <Link to={"/divadloDI"} className='dropdown-item'>
              DI
            </Link>
            <Link to={"/divadloDI#team"} className='dropdown-item'>
              Herci
            </Link>
            <Link to={"/divadloDI#co-creators"} className='dropdown-item'>
              Spolutvůrci
            </Link>
          </div>
        </div>
        <div className='navbar-dropdown-mobile'>
          <Link
            to={"/repertoar"}
            className='navbar-link'
            onClick={() => toggleDropdown("services")}
          >
            Repertoár ▼
          </Link>
          <div
            className={`dropdown-menu-mobile ${
              dropdownOpen.services ? "show" : ""
            }`}
          >
            <Link to={"/repertoar#forKids"} className='dropdown-item'>
              Pro děti
            </Link>
            <Link to={"/repertoar#forAdult"} className='dropdown-item'>
              Pro dospělé
            </Link>
            <Link to={"/repertoar#archive"} className='dropdown-item'>
              Archiv
            </Link>
          </div>
        </div>
        <Link to={"/program"} className='navbar-link'>
          Program
        </Link>
        <Link to={"/kontakty"} className='navbar-link'>
          Kontakt
        </Link>
        <a
          href='https://www.instagram.com/divadlo_di?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=='
          className='navbar-mobile-icon'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='fab fa-instagram'></i>
        </a>
        <a
          href='https://www.facebook.com/people/Divadeli%C3%A9r-Vysok%C3%A9-M%C3%BDto/61580111814101/'
          className='navbar-icon fb'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='fab fa-facebook'></i>
        </a>

        <Link to={"/adminlogin"}>
          <div className='navbar-icon'>
            <i className='fa-solid fa-pen-to-square'></i>
          </div>
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
